export const translator: Record<string, string> = {
  individual: "개별",
  mandatory: "지정",
  incumbent: "현직",
  training_individual: "현장실습 - 연수생 섭외기관",
  training_mandatory: "현장실습 - 연수기관 매칭",
  training_incumbent: "현장실습 - 연수생 근무처",
  training: "현장실습",
  life: "생활스포츠",
  pro: "전문스포츠",
  weekends: "주말",
  weekdays: "주중",
  "weekdays-b": "주중B",
  special: "특별과정",
  general: "일반과정",
  student: "학생",
  staff: "직원",
  approved: "🟢",
  True: "🟢",
  rejected: "🔴",
  False: "🔴",
  empty: "⚪️",
  uploaded: "❓",
  question: "질문",
  enhancement: "개선",
  suggestion: "건의",
  compliment: "칭찬",
  request: "공문요청",
  refund: "환불요청",
  pending: "접수대기",
  in_progress: "답변중",
  answered: "답변완료",
  attitude: "연수 태도",
  e_learning: "이론 연수",
  homework: "이론 연수 과제",
  homework_score: "과제 점수",
  training_score: "실습 점수",
  docu_post: "서류 제출",
  progress_attitude: "태도 점수",
  progress_e_learning: "이론 연수 시간",
  progress_homework_score: "과제 점수",
  progress_training_score: "실습 점수",
  progress_training_time: "실습 시간",
  progress_homework: "과제 업로드",
  progress_training: "실습서류 업로드",
  progress_docu_post: "서류 우편 제출",
};
